const MemberItemStyles = theme => ({
  img: {
    height: 215
  },
  cardContent: {
    padding: ['10px', '!important'],
    position: 'relative'
  },
  name: {
    fontSize: '18px',
    fontWeight: 500,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  subtitle: {
    fontSize: '12px',
    color: '#646262',
    marginTop: 5,
    lineHeight: '12px',
    height: 12
  },
  pillContainer: {
    marginTop: 15,
    minHeight: 21.5
  },
  memberTypePill: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: '3px 15px',
    borderRadius: 5,
    whiteSpace: 'nowrap',
    width: 'fit-content',
    margin: '0 auto'
  },
});

export default MemberItemStyles;
